import * as types from "../../constants";
import {
  signIn as authSignIn,
  signUp as authSignUp,
  refreshLogin as authRefreshLogin,
  resetPassword as authResetPassword,
} from "../../services/authService";

export function signIn(credentials) {
  return async (dispatch) => {
    dispatch({ type: types.AUTH_SIGN_IN_REQUEST });

    return authSignIn(credentials)
      .then((response) => {
        if (response.account.permissionLevel < 99) {
          throw Error("Access Denied");
        }
        localStorage.setItem("jwtToken", response.account.jwtToken);
        localStorage.setItem("refreshToken", response.refreshToken);
        dispatch({
          type: types.AUTH_SIGN_IN_SUCCESS,
          account: response.account,
          refreshToken: response.refreshToken,
        });
      })
      .catch((error) => {
        dispatch({ type: types.AUTH_SIGN_IN_FAILURE });
        throw error;
      });
  };
}

export function refreshLogin(token) {
  return async (dispatch) => {
    dispatch({ type: types.AUTH_REFRESH_REQUEST });

    return authRefreshLogin(token)
      .then((response) => {
        localStorage.setItem("jwtToken", response.account.jwtToken);
        localStorage.setItem("refreshToken", response.refreshToken);

        dispatch({
          type: types.AUTH_REFRESH_REQUEST,
          account: response.account,
          refreshToken: response.refreshToken,
        });
      })
      .catch((error) => {
        dispatch({ type: types.AUTH_SIGN_IN_FAILURE });
        throw error;
      });
  };
}

export function signUp(credentials) {
  return async (dispatch) => {
    dispatch({ type: types.AUTH_SIGN_UP_REQUEST });

    return authSignUp(credentials)
      .then((response) => {
        dispatch({
          type: types.AUTH_SIGN_UP_SUCCESS,
          id: response.id,
          email: response.email,
          name: response.name,
        });
      })
      .catch((error) => {
        dispatch({ type: types.AUTH_SIGN_UP_FAILURE });
        throw error;
      });
  };
}

export function signOut() {
  return async (dispatch) => {
    dispatch({
      type: types.AUTH_SIGN_OUT,
    });
  };
}

export function resetPassword(credentials) {
  return async (dispatch) => {
    dispatch({ type: types.AUTH_RESET_PASSWORD_REQUEST });

    return authResetPassword(credentials)
      .then((response) => {
        dispatch({
          type: types.AUTH_RESET_PASSWORD_SUCCESS,
          email: response.email,
        });
      })
      .catch((error) => {
        dispatch({ type: types.AUTH_RESET_PASSWORD_FAILURE });
        throw error;
      });
  };
}
